import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  ListItem,
  OrderedList,
  Stack,
  Switch,
  Tag,
  Textarea,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  CardFooter,
  CardHeader,
  Link as ChakraLink,
} from "@chakra-ui/react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import SignatureCanvas from "react-signature-canvas";
import taiwan_zh from ".././../../taiwan_zh";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { InfoOutlineIcon, ChevronLeftIcon } from "@chakra-ui/icons";
import { AbsenceTypeHelper } from "../../../dal/absence_type_helper";
import { SchoolPeriodHelper } from "../../../dal/school_period_helper";
import { SchoolDateHelper } from "../../../dal/school_date_helper";
import { DSAAbsenceHelper } from "../../../dal/dsa_absence_helper";
import { useUserContext } from "../../../components/auth/user-validation";
import LeaveDatePeriod from "./LeaveDatePeriod";
import { DialogBox } from "../../../components/DialogBox";
import { SchoolOtherSettingsHelper } from "../../../dal/school_other_settings_helper";
import { AbsenceType, SchoolDate, SchoolOtherSettings } from "../../../dal/value_object";
import { FileStorageHelper } from "../../../dal/file_storage_helper";
import { DatePickerIcon } from "../../../components/DatePickerIcon";
import { LeaveApplicationHelper } from "../../../dal/leave_application_helper";
import { LeaveApplicationRecord, SemesterInfo, SemesterStrInfo } from "../../../dal/value_object";
import { LoadingDialog } from "../../../components/LoadingDialog";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { PdfZoomModal } from "../../../components/Modals/PdfZoomModal";
import { useTranslation } from "react-i18next";
import { Util } from "../../../dal/util";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
// 啟用時區套件
dayjs.extend(utc);
dayjs.extend(timezone);
// 設定預設時區為台灣時區
dayjs.tz.setDefault('Asia/Taipei');

/** 預先請假主畫面 */
export const InAdvance = () => {
  const { userInfo } = useUserContext();
  const navigate = useNavigate();
  const cancelRef = React.useRef(null);
  const { onClose } = useDisclosure();
  const { t, i18n } = useTranslation("translation");
  const fileInputRef = useRef(null) //使用者選擇檔案的input ref

  // ====== 退回重填 =====
  const location = useLocation();
  const oldData = location.state?.oldData;

  // ====== 學校設定值 =====
  const [absenceTypes, setAbsenceTypes] = useState<AbsenceType[]>([]); // 學校在本學期允許請假的假別
  const [allowedPeriods, setAllowedPeriods] = useState<string[]>([]); // 學校在本學期允許請假的節次
  const [schoolDates, setSchoolDates] = useState<SchoolDate[]>([]); // 學校在本學期定義的上課日
  const [currentSemester, setCurrentSemester] = useState<SemesterStrInfo>({ school_year: String(userInfo?.schoolYear ?? ''), semester: String(userInfo?.semester ?? '') }); // 學校在上課日定義的目前學年度學期
  const [schoolOtherSettings, setSchoolOtherSettings] =
    useState<SchoolOtherSettings | null>(null); // 學校其他設定
  const [isSettingReady, setIsSettingReady] = useState<boolean>(false); // 學校是否已經完成設定

  // ===== 紀錄使用者操作 =====
  const [isDialogBoxOpened, setIsDialogBoxOpened] = useState<boolean>(false); // 是否開啟提示的對話方塊
  const [isDepartedStudentDialogBoxOpened, setIsDepartedStudentDialogBoxOpened] = useState<boolean>(false); // 是否開啟提示的對話方塊
  const todayString = dayjs().format('YYYY/MM/DD')
  const today = dayjs.tz().startOf('day');
  const [selectedRangeDates, setSelectedRangeDates] = useState<any[]>([new DateObject()]); // 日期控制項的 controled component 
  const [selectedDates, setSelectedDates] = useState<string[]>([]); // 使用者選擇要請假的日期
  const [selectedOption, setSelectedOption] = useState<AbsenceType | null>(null); // 使用者選擇要請的假別
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined); // 暫存使用者選擇的附件
  const [leaveDatePeriods, setLeaveDatePeriods] = useState<{
    [dt: string]: string[];
  }>({}); // 暫存使用者已選擇要請假的日期與節次
  const [absReason, setAbsReason] = useState<string | null>(""); // 暫存請假理由
  const [isInputDataReady, setIsInputDataReady] = useState<boolean>(false); // 請假填寫資料是否已齊備可送出
  const [showLoading, setShowLoading] = useState<boolean>(false); // 是否顯示載入中圖示的視窗
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [schoolOtherSetting, setSchoolOtherSetting] = useState<any>({}); // 學校的其他設定
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");

  interface LeaveDate {
    ref_leave_application_id: string;
    date: string;
    periods: string[];
  }
  const [leaveDates, setLeaveDates] = useState<LeaveDate[]>([]); // 這位學生的所有請假日期

  const [minDate, setMinDate] = useState<Date | null>(null);
  const {
    isOpen: isSignOpen,
    onOpen: onSignOpen,
    onClose: onSignClose,
  } = useDisclosure();
  const {
    onOpen: onRuleOpen,
    isOpen: isRuleOpen,
    onClose: onRuleClose,
  } = useDisclosure();
  const showAlert = (msg: string) => {
    setAlertMessage(msg);
    setIsAlertDialogOpen(true);
  };
  const [imageURL, setImageURL] = useState<string | undefined>(undefined);
  const sigCanvas = useRef<SignatureCanvas | null>(null);
  const clear = () => sigCanvas.current?.clear();
  const save = () => {
    setImageURL(
      sigCanvas.current?.getTrimmedCanvas()?.toDataURL("/assets/img/png") ??
      undefined
    );
  };

  useEffect(() => {
    if (!oldData || !absenceTypes) return;
    setSelectedOption(absenceTypes.find((absType) => absType.type === oldData.absence_type) || null);

    const oldDatePeriod: Record<string, string[]> = {};
    const oldSelectedDates: string[] = [];

    oldData.leaveDateAndPeriod?.forEach((item: any) => {
      const formattedDate = item.d.replace(/-/g, '/'); // 轉換日期格式
      oldDatePeriod[formattedDate] = item.periods;
      oldSelectedDates.push(formattedDate);
    });

    // 找出第一天和最後一天
    const sortedDates = [...oldSelectedDates].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const oldSelectedRangeDates = sortedDates.length > 0 ? [sortedDates[0], sortedDates[sortedDates.length - 1]] : [];

    setLeaveDatePeriods(oldDatePeriod);
    setSelectedDates(oldSelectedDates);
    setSelectedRangeDates(oldSelectedRangeDates);
    setAbsReason(oldData?.reason);
    setCurrentSemester({ school_year: oldData.school_year, semester: oldData.semester });
  }, [oldData, absenceTypes]);

  /** 元件初始化時 */
  useEffect(() => {
    console.log("一般請假，InAdvance useEffect []");
    loadData();
    // handleDateChange([new DateObject()])
  }, []);

  useEffect(() => {
    checkStudentDeparted();
  }, [userInfo]);

  useEffect(() => {
    if (oldData) return;
    handleDateChange([new DateObject()]);
  }, [oldData, schoolDates]);

  /** 當這些變數有變動時 */
  useEffect(() => {
    checkData();
  }, [selectedDates, selectedOption, leaveDatePeriods, absReason, imageURL]);

  useEffect(() => {
    // 可請假區間 school_other_settings.date_range (不限制 : null / 當學期 : -1  / 日數 : 30)
    if (schoolOtherSettings?.date_range === null || oldData) {
      //不限制最小日期
      setMinDate(null);
      console.log("minDate", null);
    } else if (schoolOtherSettings?.date_range === -1) {
      console.log("minDate", dayjs(schoolDates[0].d));
      setMinDate(dayjs(schoolDates[0].d).startOf('day').toDate());
    } else if (schoolOtherSettings?.date_range === 0) {
      // 只能請今天
      setMinDate(dayjs(today).startOf('day').toDate());
      return;
    } else {
      // 上課日往回推 N 個上課日 schoolDates

      // console.log({ schoolDates, schoolOtherSettings, today });
      const n = Number(schoolOtherSettings?.date_range);

      // 將 schoolDates 轉換為 dayjs 並過濾出今天以前的日期
      const pastSchoolDays = schoolDates
        .map(item => dayjs(item.d, 'YYYY/MM/DD').startOf('day'))
        // .filter(d => !d.isAfter(today)) // d <= today
        .filter(d => d.isBefore(today)) // < today
        .sort((a, b) => b.valueOf() - a.valueOf()); // 由近到遠排序

      // console.log({ pastSchoolDays, n });

      if (pastSchoolDays.length >= n) {
        const min = pastSchoolDays[n - 1].toDate(); // 往回推第 n 個上課日
        setMinDate(min);
        console.log("minDate", min);
      } else {
        // 沒有足夠的過去上課日 => 設定最早的可用上課日
        const min = pastSchoolDays[pastSchoolDays.length - 1]?.toDate() ?? null;
        setMinDate(min);
        console.log("minDate", min);
      }
      //setMinDate(dayjs().startOf('day').add(-Math.abs(Number(schoolOtherSettings?.date_range)), 'day').toDate());
    }
  }, [schoolOtherSettings?.date_range, schoolDates, oldData]);

  /** 讀取資料 */
  const loadData = async () => {
    try {
      setShowLoading(true);

      const allSemDates = await SchoolDateHelper.getDatesForAllSemester('');

      // 判斷今日落在哪個學期(只比較日期,不比較時間)
      const currentSemesterObj = allSemDates.find(d => {
        const beginDate = dayjs(d.begin_date).startOf('day');
        const endDate = dayjs(d.end_date).startOf('day');
        return today.isSameOrAfter(beginDate) && today.isSameOrBefore(endDate);
      });

      const schoolYear = oldData?.school_year ?? currentSemesterObj?.school_year ?? userInfo?.schoolYear;
      const semester = oldData?.semester ?? currentSemesterObj?.semester ?? userInfo?.semester;

      setCurrentSemester({ school_year: String(schoolYear), semester: String(semester) });

      // 上課日：有找到學期就用該學期的，否則抓預設學年度學期
      const schoolDates = currentSemesterObj?.dates ?? await SchoolDateHelper.getDatesBySemester();
      setSchoolDates(schoolDates);


      const [absenceTypes, allowedPeriods, otherSettings] = await Promise.all([
        AbsenceTypeHelper.getAllowedAbsenceTypes(semester),
        SchoolPeriodHelper.getAllowedPeriods(semester),
        SchoolOtherSettingsHelper.get()
      ]);

      // 取得學生假單日期
      const leaveDates = await LeaveApplicationHelper.getStudentHistoriesDatesByCurrentSemester(schoolYear, semester);

      setAbsenceTypes(absenceTypes);
      setAllowedPeriods(allowedPeriods);

      setSchoolOtherSettings(otherSettings);
      setLeaveDates(leaveDates);

      // 檢查學校需設定資料是否齊全
      const isReady =
        absenceTypes.length > 0 &&
        allowedPeriods.length > 0 &&
        schoolDates.length > 0 &&
        !!otherSettings?.id &&
        leaveDates !== undefined;

      setIsSettingReady(isReady);
      setIsDialogBoxOpened(!isReady);

      const setting = await SchoolOtherSettingsHelper.getSchoolOtherSettings();
      setSchoolOtherSetting(setting);
    } catch (ex) {
      console.log('loadData ex', ex);
    } finally {
      setShowLoading(false);
    }
  };

  const handleAbsenceTypeChange = (value: AbsenceType) => {
    setSelectedOption(value);
  };

  // 處理日期改變的事件
  const handleDateChange = (e: DateObject[]) => {
    // 如果選了開始和結束日，才進行處理，找出有效上課日。
    const bd = e[0].toString();
    const ed = e.length > 1 ? e[1].toString() : bd;
    console.log('handleDateChange', { e, bd, ed });
    // if (e.length > 1) {
    const dates = findValidDates(bd, ed); // 找出有效的日期，可能根據上課日，或是否假日來判斷。
    setSelectedDates(dates); // 紀錄使用者選取的有效日期清單
    console.log({ dates });
    setLeaveDatePeriods({}); // 清空選取的日期與節次
  };

  /** 當 日曆關閉時 */
  const handleDataPickerClosed = (e: any) => {
    console.log("picker closed");
  };

  /** 處理使用者選擇某一天要請假的節次後 */
  const handleDatePeriodChanged = (dt: string, periods: string[]) => {
    console.log({ dt, periods });
    const isRightDate = selectedDates.find((sd) => sd === dt);
    if (isRightDate) {
      const tempLeaveDatePeriod = { ...leaveDatePeriods };
      tempLeaveDatePeriod[dt] = periods;
      setLeaveDatePeriods(tempLeaveDatePeriod);
    }
  };

  //
  const handleAbsReasonChanged = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setAbsReason(e.target.value);
  };

  /**
   * 檢查找出有效的日期
   * 如果學校有定義上課日，則以上課日為主，否則就檢查排除六日
   * */
  const findValidDates = (beginDate: string, endDate: string): string[] => {
    const result: string[] = [];
    let bd = dayjs(beginDate);
    // 開始日期不能早於今天
    // if (bd.format('YYYYMMDD') < dayjs().format('YYYYMMDD')) {
    //   bd = dayjs();
    // }
    const ed = dayjs(endDate);
    let targetD = bd;
    while (targetD <= ed) {
      // console.log({ targetD });
      let isValidDate = false;
      if (schoolDates.length > 0) {
        const td = schoolDates.find(
          (sd) =>
            targetD.format("YYYY/MM/DD") === dayjs(sd.d).format("YYYY/MM/DD")
        );
        isValidDate = !!td;
      } else {
        // 學校沒有定義上課日，就直接排除六日
        isValidDate = targetD.day() !== 0 && targetD.day() !== 6;
      }
      // 如果是有效的上課日，才讓使用者進行請假
      if (isValidDate) {
        result.push(targetD.format("YYYY/MM/DD"));
      }
      targetD = targetD.add(1, "day");
    }
    return result;
  };

  /** 暫存使用者選取的檔案 */
  const handleAttachFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const targetFIle = e.target.files[0];
      console.log({ targetFIle });
      if (FileStorageHelper.isImageFormat(targetFIle)) {
        setSelectedFile(targetFIle);
      } else {
        showAlert('上傳檔案格式錯誤. 請選擇圖檔(.jpg, .jpeg, .png, .gif, .heic, .heif).');
        // window.alert('上傳檔案格式錯誤e. 請選擇圖檔(.jpg, .jpeg, .png, .gif, .heic, .heif).');
      }
    }
  };

  /** 點擊上傳檔案外觀按鈕，開啟檔案選擇視窗 */
  const handleUploadFileClick = () => {
    if (fileInputRef.current) {
      (fileInputRef.current as HTMLInputElement).click();
    }
  }

  /** 上傳檔案 */
  const uploadFile = async (file: File | undefined) => {
    if (!file) return;
    try {
      const attInfo = await FileStorageHelper.uploadFile(file);
      console.log({ attInfo });
      return attInfo;
    } catch (ex) {
      throw ex;
    }
  };

  /** 檢查使用者是否已輸入所有必要資訊 */
  const checkData = () => {
    console.log(" checkData() ...");

    let result = true;
    // 1. 是否選取日期
    result = result && selectedDates.length > 0;

    // 2. 是否選取假別
    result = result && !!selectedOption;

    // 3. 是否有日期沒有選節次
    selectedDates.forEach((sd) => {
      result =
        result && !!leaveDatePeriods[sd] && leaveDatePeriods[sd].length > 0;
    });

    // 4. 是否輸入請假原因
    result = result && !!absReason;

    // 5. 檢查是否簽名
    const needParentSign = schoolOtherSettings
      ? schoolOtherSettings.need_parent_approval
      : false;
    if (needParentSign && userInfo?.roleType === "parent" && !imageURL) {
      result = result && false;
      // window.alert("需要簽名");
    }
    //6. 檢查選擇假別格式
    if (selectedOption && typeof selectedOption.type === 'string') {
      try {
        const parsed = JSON.parse(selectedOption.type);
        if (typeof parsed === 'object') {
          // type is a JSON string
          result = result && false;
        }
      } catch {
        // type is a regular string, not JSON
        result = result && true;
      }
    }

    setIsInputDataReady(result);

    return result;
  };

  // 檢查是否為在校生
  const checkStudentDeparted = async () => {
    const schoolDsns = String(userInfo?.schoolDsns ?? "");
    const studentID = String(userInfo?.parent?.studentID ?? "") || String(userInfo?.student?.studentID ?? "");
    const result = await DSAAbsenceHelper.getStudentDeparted(schoolDsns, studentID);
    console.log(userInfo, result);
    if (!result) {
      // alert("只限在校生請假！");
      setIsDepartedStudentDialogBoxOpened(true);
      return;
    }
  }
  /** 判斷節次是否為生理假採計的正課節次 (僅採計 1~7 節或 一~七 節) */
  const isValidMenstrualPeriod = (periodName: string): boolean => {
    if (!periodName) return false;
    // 移除字首「第」與字尾「節」，例如 "第1節" -> "1", "第一節" -> "一"
    const cleanP = periodName.trim().replace(/^第/, '').replace(/節$/, '');
    const validSet = new Set(['1', '2', '3', '4', '5', '6', '7', '一', '二', '三', '四', '五', '六', '七']);
    return validSet.has(cleanP);
  };

  /** 驗證生理假規則 (含歷史假單累加計算) */
  const validateMenstrualLeave = async (): Promise<{ valid: boolean; message?: string }> => {
    // 1. 先檢查本次選擇假別是否為生理假，非生理假直接放行
    const isMenstrualLeave = selectedOption?.type === '生理假';
    if (!isMenstrualLeave) return { valid: true };

    // 2. 確定是生理假後，才向後端撈取學生本學期的歷史假單
    const histories = await LeaveApplicationHelper.getStudentHistoriesBySchoolYearAndSemester(
      currentSemester.school_year?.toString(),
      currentSemester.semester?.toString()
    );

    // 3. 取得生理假設定
    const rule = (schoolOtherSettings as any)?.menstrual_leave_rule || {
      unit: 'day',
      max_monthly_limit: 1,
      allow_cross_day: true,
    };

    const { unit, max_monthly_limit = 1, allow_cross_day = true } = rule;

    // 4. 過濾出有效的歷史生理假假單 (排除 rejected、canceled、退回單會在此被排除)
    const validHistories = (histories || []).filter((item: any) => {
      const status = (item.status || '').toLowerCase();
      if (status === 'rejected' || status === 'canceled') {
        return false;
      }

      const isHistoryMenstrual = item.absence_type === '生理假' || item.absence_type?.includes('生理假');
      return isHistoryMenstrual;
    });

    // 5. 解析歷史生理假假單，按月份（YYYY/MM）統計已使用額度
    const historyMonthMap: {
      [monthKey: string]: {
        dates: Set<string>;                 // 已請假的日期
        validPeriodsCount: number;         // 已請的正課節數 (1~7 / 一~七)
        datesWithValidPeriods: Set<string>; // 含有正課的日期
      };
    } = {};

    validHistories.forEach((item: any) => {
      (item.leaveDateAndPeriod || []).forEach((ld: any) => {
        const formattedDate = dayjs(ld.d).format('YYYY/MM/DD');
        const monthKey = dayjs(ld.d).format('YYYY/MM');

        if (!historyMonthMap[monthKey]) {
          historyMonthMap[monthKey] = {
            dates: new Set(),
            validPeriodsCount: 0,
            datesWithValidPeriods: new Set(),
          };
        }

        historyMonthMap[monthKey].dates.add(formattedDate);

        let hasValidPeriod = false;
        (ld.periods || []).forEach((p: string) => {
          if (isValidMenstrualPeriod(p)) {
            historyMonthMap[monthKey].validPeriodsCount += 1;
            hasValidPeriod = true;
          }
        });

        if (hasValidPeriod) {
          historyMonthMap[monthKey].datesWithValidPeriods.add(formattedDate);
        }
      });
    });

    // 6. 按月份分類本次新申請的日期
    const currentMonthMap: { [monthKey: string]: string[] } = {};
    selectedDates.forEach(d => {
      const monthKey = dayjs(d, 'YYYY/MM/DD').format('YYYY/MM');
      if (!currentMonthMap[monthKey]) currentMonthMap[monthKey] = [];
      currentMonthMap[monthKey].push(d);
    });

    // 7. 進行「歷史額度 + 本次新申請額度」的合併驗證
    for (const [monthKey, currentDates] of Object.entries(currentMonthMap)) {
      const hist = historyMonthMap[monthKey] || {
        dates: new Set<string>(),
        validPeriodsCount: 0,
        datesWithValidPeriods: new Set<string>(),
      };

      if (unit === 'day') {
        // 【以天為單位】
        const combinedDates = new Set([...Array.from(hist.dates), ...currentDates]);
        if (combinedDates.size > max_monthly_limit) {
          const histCount = hist.dates.size;
          return {
            valid: false,
            message: `生理假以「天」為單位，單月（${monthKey}）請假上限為 ${max_monthly_limit} 天。` +
              (histCount > 0 ? `您在本月已有 ${histCount} 天歷史假單紀錄，` : '') +
              `加總後將超過限制。`,
          };
        }
      } else if (unit === 'period') {
        // 【以節為單位】
        let currentValidPeriodCount = 0;
        const currentDatesWithValidPeriods = new Set<string>();

        currentDates.forEach(dt => {
          const periods = leaveDatePeriods[dt] || [];
          let hasValidPeriod = false;
          periods.forEach(p => {
            if (isValidMenstrualPeriod(p)) {
              currentValidPeriodCount += 1;
              hasValidPeriod = true;
            }
          });
          if (hasValidPeriod) {
            currentDatesWithValidPeriods.add(dt);
          }
        });

        // 如果本次填寫完全不包含正課節次 (例如只選了早修、午休、第八節)，無視生理假規則直接放行
        if (currentValidPeriodCount === 0) continue;

        // 總正課節數 = 歷史正課節數 + 本次正課節數
        const totalValidPeriods = hist.validPeriodsCount + currentValidPeriodCount;

        // 所有含有正課的日期集合
        const combinedValidDates = new Set([
          ...Array.from(hist.datesWithValidPeriods),
          ...Array.from(currentDatesWithValidPeriods),
        ]);

        // (A) 檢查是否跨日
        if (!allow_cross_day && combinedValidDates.size > 1) {
          const currentDatesStr = Array.from(currentDatesWithValidPeriods).join('、');
          const histDatesStr = Array.from(hist.datesWithValidPeriods).join('、');

          // 情境 1：本次假單「自己」就勾選了超過 1 天的日期
          if (currentDatesWithValidPeriods.size > 1) {
            return {
              valid: false,
              message: `根據學校規定，生理假以「節」為單位時，單月上限 7 節正課且「不得跨日」（所有節數必須集中於同一天請完）。您本次假單勾選了多個日期（${currentDatesStr}），請調整為單一日期後再送出。`,
            };
          }

          // 情境 2：本次假單雖然只有 1 天，但加上「當月歷史假單」後產生跨日
          if (hist.datesWithValidPeriods.size > 0) {
            return {
              valid: false,
              message: `根據學校規定，生理假以「節」為單位時，單月上限 7 節正課且「不得跨日」（當月所有節數必須集中於同一天請完）。您在當月（${monthKey}）已有歷史請假紀錄（${histDatesStr}），無法再於不同日期（${currentDatesStr}）申請生理假。`,
            };
          }
        }

        // (B) 檢查單月正課節數上限
        if (totalValidPeriods > max_monthly_limit) {
          return {
            valid: false,
            message: `生理假單月（${monthKey}）上限為 ${max_monthly_limit} 節正課。` +
              (hist.validPeriodsCount > 0 ? `包含歷史假單（已請 ${hist.validPeriodsCount} 節），` : '') +
              `本次申請後總計為 ${totalValidPeriods} 節，已超過上限。`,
          };
        }
      }
    }

    return { valid: true };
  };
  /** 判斷節次屬於哪個半日 (1~4節: morning / 5~7節: afternoon) */
  const getHalfDayType = (periodName: string): 'morning' | 'afternoon' | null => {
    if (!periodName) return null;
    const cleanP = periodName.trim().replace(/^第/, '').replace(/節$/, '');
    if (['1', '2', '3', '4', '一', '二', '三', '四'].includes(cleanP)) return 'morning';
    if (['5', '6', '7', '五', '六', '七'].includes(cleanP)) return 'afternoon';
    return null;
  };

  /** 計算單日節次清單涵蓋幾個半日 (0, 1, 或 2) */
  const countHalfDaysForPeriods = (periods: string[]): number => {
    let hasMorning = false;
    let hasAfternoon = false;
    (periods || []).forEach(p => {
      const type = getHalfDayType(p);
      if (type === 'morning') hasMorning = true;
      if (type === 'afternoon') hasAfternoon = true;
    });
    return (hasMorning ? 1 : 0) + (hasAfternoon ? 1 : 0);
  };


  /** 驗證身心調適假規則 (固定規則：一學期最多 6 個半日) */
  const validateMentalHealthLeave = async (): Promise<{ valid: boolean; message?: string }> => {
    // 1. 檢查本次選擇假別是否為身心調適假
    const isMentalHealthLeave = selectedOption?.type === '身心調適假';
    if (!isMentalHealthLeave) return { valid: true };

    // 2. 先計算「本次申請」佔用的半日數
    let currentHalfDays = 0;
    selectedDates.forEach(dt => {
      const periods = leaveDatePeriods[dt] || [];
      currentHalfDays += countHalfDaysForPeriods(periods);
    });

    // 比照生理假邏輯：如果本次選擇完全沒用到正課半日 (例如只選了早修、午休、第八節)
    // 代表沒有動用到額度，無視身心調適假限制，直接放行 (也不發送歷史紀錄 API 請求)
    if (currentHalfDays === 0) {
      return { valid: true };
    }

    // 3. 確定有動用到正課半日額度後，向後端撈取學生本學期的歷史假單
    const histories = await LeaveApplicationHelper.getStudentHistoriesBySchoolYearAndSemester(
      currentSemester.school_year?.toString(),
      currentSemester.semester?.toString()
    );

    // 4. 過濾出有效的歷史身心調適假紀錄 (排除 rejected, canceled)
    const validHistories = (histories || []).filter((item: any) => {
      const status = (item.status || '').toLowerCase();
      if (status === 'rejected' || status === 'canceled') {
        return false;
      }
      return item.absence_type === '身心調適假';
    });

    // 5. 統計「歷史假單」累計的半日數 (全學期)
    let historyHalfDays = 0;
    validHistories.forEach((item: any) => {
      (item.leaveDateAndPeriod || []).forEach((ld: any) => {
        historyHalfDays += countHalfDaysForPeriods(ld.periods || []);
      });
    });

    // 6. 驗證全學期上限 (最多 6 個半日)
    const MAX_HALF_DAYS = 6;
    const totalHalfDays = historyHalfDays + currentHalfDays;

    if (totalHalfDays > MAX_HALF_DAYS) {
      return {
        valid: false,
        message: `「身心調適假」一學期上限為 ${MAX_HALF_DAYS} 個半日。` +
          (historyHalfDays > 0 ? `您本學期已有 ${historyHalfDays} 個半日歷史紀錄，` : '') +
          `本次申請 ${currentHalfDays} 個半日（總計 ${totalHalfDays} 個半日），已超過學期上限。`,
      };
    }

    return { valid: true };
  };
  /** 送出申請單 */
  const submitLeaveApplication = async () => {
    // 檢查請假日數強制附件上傳
    if (((selectedOption?.min_days ?? 0) <= selectedDates.length) && (selectedFile === undefined && !oldData?.attachment_info) && ((selectedOption?.min_days ?? 0) !== -1)) {
      const dayPrefix = selectedDates.length === 1 ? '' : `${selectedDates.length}天以上的`;
      // alert(`根據學校規定，${dayPrefix}${selectedOption?.type}需提交相關附件，請上傳附件再送出假單。`);
      showAlert(`根據學校規定，${dayPrefix}${selectedOption?.type}需提交相關附件，請上傳附件再送出假單。`);
      return;
    }
    setShowLoading(true);
    try {
      // 檢查生理假規則
      const menstrualCheck = await validateMenstrualLeave();
      if (!menstrualCheck.valid) {
        setShowLoading(false); // 關閉 Loading
        showAlert(menstrualCheck.message || '');
        return;
      }


      // 檢查身心調適假規則
      const mentalHealthCheck = await validateMentalHealthLeave();
      if (!mentalHealthCheck.valid) {
        setShowLoading(false);
        showAlert(mentalHealthCheck.message || '');
        return;
      }

      console.log("submit application");


      let isReady = true;

      let attInfo;
      // 確認附件
      try {
        //有oldDate.attachment_info & 沒有檔案變動的時候不用上傳
        if (oldData?.attachment_info && !selectedFile)
          attInfo = oldData.attachment_info;
        else
          attInfo = await uploadFile(selectedFile);
      } catch (ex: any) {
        console.log({ ex });
        if (ex.code === 413) {
          showAlert('附件大小超過 5MB. 請壓縮或裁剪至 5MB 以下後再上傳。');
          // alert('附件大小超過 5MB. 請壓縮或裁剪至 5MB 以下後再上傳。');
        } else {
          showAlert('上傳附件失敗！' + ex.msg);
          // alert('上傳附件失敗！' + ex.msg);
        }
        isReady = false;
      }

      // 上傳簽名檔
      let signFileInfo;

      if (isReady) {   // 如果前一步驟成功，才繼續這個步驟上傳簽名檔。
        let signFile = FileStorageHelper.convertDataURLtoFile(
          imageURL,
          "parent_signature"
        );
        // 把 imageUrl 轉成 File 物件
        try {
          signFileInfo = await uploadFile(signFile);
          console.log({ signFileInfo });
        } catch (ex) {
          console.log({ ex });
          isReady = false;
        }
      }

      if (isReady) {
        // 4. 送出

        const data = {
          absence_type: selectedOption?.type,
          leaveDateAndPeriod: makeLeaveDateAndPeriodPayload(),
          reason: absReason,
          need_parent_signature: schoolOtherSettings?.need_parent_approval,
          attachment_info: attInfo,
          parent_sign_info: signFileInfo,
          schoolYear: currentSemester?.school_year,
          semester: currentSemester?.semester,
          special_tag: oldData ? "resubmitted" : "regular",
        };
        // console.log( { data });
        const resp = await LeaveApplicationHelper.send(data);

        setShowLoading(false);
        navigate("../history");
      } else {
        setShowLoading(false);
      }

    } catch (error: any) {
      setShowLoading(false);
      showAlert('送出假單時發生系統錯誤，請稍後再試。');
    }
  };

  const makeLeaveDateAndPeriodPayload = () => {
    const result = selectedDates.map((sd) => ({
      d: sd,
      periods: leaveDatePeriods[sd],
    }));

    return result;
  };

  return (
    <>
      <div className="max-w-md bg-slate-100 h-screen p-4">
        <div className="flex items-center gap-3">
          <div className="flex-1 text-start">
            <Button
              colorScheme="blue"
              variant="ghost"
              size="md"
              className="!p-0 w-fit"
              onClick={() => navigate(-1)}
              leftIcon={
                <Icon w={6} h={6} color="blue.500" viewBox="0 0 24 24">
                  <g fill="none" fillRule="evenodd">
                    <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                    <path
                      fill="currentColor"
                      d="M8.293 12.707a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 1 1 1.414 1.414L10.414 12l4.95 4.95a1 1 0 0 1-1.414 1.414z"
                    />
                  </g>
                </Icon>
              }
            >
              {/* <span>返回主頁</span> */}
            </Button>
          </div>
          <div className="text-center text-lg font-semibold grow">
            {t("app.regular_leave")}
          </div>
          <div className="flex-1" />
        </div>

        <div className="flex flex-wrap items-center pt-3 gap-2">
          <div className="flex">
            <span className="">{currentSemester ? Util.formatSemesterLabel(currentSemester, i18n.language) : ""}</span>
          </div>

          {/*<div onClick={()=>setIsPdfModalOpen(true)} className="cursor-pointer">          
            <InfoOutlineIcon />
              <span className="ms-1 align-middle">請假規定</span>
          </div>*/}
          <ChakraLink href={schoolOtherSetting?.leave_rule + '?__target=InAppBrowser'} isExternal className="cursor-pointer ms-auto" style={{ textDecoration: 'none' }}>
            <InfoOutlineIcon />
            <span className="ms-2 align-middle">{t("app.rules_of_leave")}</span>
          </ChakraLink>
        </div>

        {
          (schoolDates.length === 0) && (
            <div className="flex justify-between items-center pb-2 pl-2 ">
              <div className=" text-red-500 font-bold">{t("app.no_class_days_set")}</div>
            </div>
          )
        }

        <Card className="h-stud-ad overflow-auto !rounded-2xl mt-4">
          <div className="text-left p-4">
            <OrderedList spacing={3}>
              <ListItem className="font-semibold">{t("app.leave_dates")}</ListItem>
              <div className="!mt-2 pr-4">
                {/* 重新填單時，禁止選日期 */}
                <InputGroup className={oldData ? "!pointer-events-none opacity-60" : ""}>
                  <DatePicker
                    range
                    minDate={minDate || undefined}
                    locale={taiwan_zh}
                    value={selectedRangeDates}
                    onChange={handleDateChange}
                    render={<InputIcon />}
                  />
                  {/* <InputRightElement>
                    <DatePickerIcon />
                  </InputRightElement> */}
                </InputGroup>
              </div>
              <ListItem className="font-semibold">
                {t("app.leave_category_l")}{" "}
                {!selectedOption && (
                  <span className="text-sm text-red-500 ms-2">{t("app.leave_category_not_selected")}</span>
                )}
              </ListItem>
              <div className="!mt-2">
                <Stack align="center" direction="row" className="flex-wrap">
                  {absenceTypes.map((absType) => (
                    <Switch
                      key={absType.type}
                      size="lg"
                      colorScheme="twitter"
                      content={absType.type}
                      className="switch-txt"
                      onChange={() => handleAbsenceTypeChange(absType)}
                      isChecked={selectedOption?.type === absType.type}
                    />
                  ))}
                </Stack>
              </div>
              <ListItem className="font-semibold">
                {/* 請假天數 */}
                {t("app.leave_sessions")} ( {selectedDates.length} {t("app.day")} {(selectedDates.length === 0) && (<>，<span className="text-sm text-red-500 ms-2">{t("app.selected_dates_no_class_days")}</span> </>)})
              </ListItem>
              {/* 重新填單時，禁止選節次 */}
              <div className={oldData ? "!pointer-events-none opacity-60" : ""}>
                {selectedDates.map((sd) => (
                  <LeaveDatePeriod
                    key={sd}
                    targetDate={sd}
                    isLeaveDate={!!leaveDates.find((ld) => Util.formatDate(ld.date) === sd)}
                    allowPeriods={allowedPeriods}
                    oldLeaveDatePeriods={leaveDatePeriods || {}}
                    onSelected={handleDatePeriodChanged}
                  />
                ))}
              </div>

              <ListItem className="font-semibold">
                {t("app.leave_reason_l")} {" "}
                {!absReason && (
                  <span className="text-sm text-red-500 ms-2">{t("app.leave_reason_unfilled")}</span>
                )}
              </ListItem>

              <div className="pr-4">
                <Textarea
                  placeholder={t("app.enter_leave_reason")}
                  value={absReason || ""}
                  onChange={handleAbsReasonChanged}
                />
              </div>
              <ListItem className="font-semibold">{t("app.upload_attachment")}
                {(userInfo?.roleType === "parent" &&
                  schoolOtherSettings?.need_parent_approval) && (t("app.and_parent_sign"))}
              </ListItem>
              <InputGroup className="!grid grid-cols-1 gap-4 w-auto pr-4 ">
                {/* 選擇檔案的按鈕，為了翻譯做一個外表 */}
                <Input
                  type="text"
                  placeholder="Enter amount"
                  className="w-full z-10 cursor-pointer"
                  isReadOnly={true}
                  onClick={handleUploadFileClick}
                  value={selectedFile?.name || oldData?.attachment_info?.filename || t("app.no_file_selected")}
                />
                <Input
                  type="file"
                  placeholder="Enter amount"
                  className="w-full pt-2 z-10  cursor-pointer hidden"
                  accept=".jpg, .jpeg, .png, .gif, .heic, .heif"
                  onChange={handleAttachFileChange}
                  ref={fileInputRef}
                />
                <InputRightElement className="!right-4">
                  <Icon w={6} h={6} color="gray.500" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16zm-5 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
                    />
                  </Icon>
                </InputRightElement>

                {/* 簽名按鈕 */}
                {userInfo?.roleType === "parent" &&
                  schoolOtherSettings?.need_parent_approval && (
                    <div className="flex flex-wrap gap-3 items-end">
                      {imageURL && (
                        <div className="mx-auto flex-shrink-0">
                          <img
                            src={imageURL}
                            alt="Signature"
                            className="h-28 mx-auto"
                          />
                        </div>
                      )}
                      <Button
                        onClick={onSignOpen}
                        rightIcon={
                          <Icon
                            w={6}
                            h={6}
                            color="gray.500"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M9.75 20.85c1.78-.7 1.39-2.63.49-3.85c-.89-1.25-2.12-2.11-3.36-2.94A9.817 9.817 0 0 1 4.54 12c-.28-.33-.85-.94-.27-1.06c.59-.12 1.61.46 2.13.68c.91.38 1.81.82 2.65 1.34l1.01-1.7C8.5 10.23 6.5 9.32 4.64 9.05c-1.06-.16-2.18.06-2.54 1.21c-.32.99.19 1.99.77 2.77c1.37 1.83 3.5 2.71 5.09 4.29c.34.33.75.72.95 1.18c.21.44.16.47-.31.47c-1.24 0-2.79-.97-3.8-1.61l-1.01 1.7c1.53.94 4.09 2.41 5.96 1.79m11.09-15.6c.22-.22.22-.58 0-.79l-1.3-1.3a.562.562 0 0 0-.78 0l-1.02 1.02l2.08 2.08M11 10.92V13h2.08l6.15-6.15l-2.08-2.08z"
                            />
                          </Icon>
                        }
                        className="w-full"
                      >
                        {imageURL ? (t("app.resign")) : (t("app.start_to_sign"))}
                      </Button>

                    </div>
                  )}
              </InputGroup>
            </OrderedList>
            <Button
              leftIcon={
                <Icon w={6} h={6} color="white" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M7.1 11.35q.35-.7.725-1.35t.825-1.3l-1.4-.275l-2.1 2.1zm12.05-6.875q-1.75.05-3.737 1.025T11.8 8.1q-1.05 1.05-1.875 2.25T8.7 12.6l2.85 2.825q1.05-.4 2.25-1.225t2.25-1.875q1.625-1.625 2.6-3.6T19.675 5q0-.1-.038-.2t-.112-.175q-.075-.075-.175-.112t-.2-.038m-5.5 6q-.575-.575-.575-1.412t.575-1.413q.575-.575 1.425-.575t1.425.575q.575.575.575 1.413t-.575 1.412q-.575.575-1.425.575t-1.425-.575m-.85 6.55L13.625 19l2.1-2.1l-.275-1.4q-.65.45-1.3.813t-1.35.712m8.775-13.35q.2 2.75-.9 5.363T17.2 14.025l.5 2.475q.1.5-.05.975t-.5.825L14 21.45q-.375.375-.9.288t-.725-.588l-1.525-3.575L6.575 13.3L3 11.775q-.5-.2-.6-.725t.275-.9L5.825 7q.35-.35.837-.5t.988-.05l2.475.5q2.375-2.375 4.988-3.475t5.362-.9q.2.025.4.113t.35.237q.15.15.238.35t.112.4m-17.65 12.3q.875-.875 2.138-.887t2.137.862q.875.875.863 2.138t-.888 2.137q-1.2 1.2-2.838 1.425t-3.287.45l.45-3.287q.225-1.637 1.425-2.838m1.425 1.4q-.425.425-.587 1.025T4.5 19.625q.625-.1 1.225-.25T6.75 18.8q.3-.3.325-.725T6.8 17.35q-.3-.3-.725-.288t-.725.313"
                  />
                </Icon>
              }
              colorScheme="twitter"
              className="w-full my-8 disabled"
              onClick={submitLeaveApplication}
              isDisabled={(schoolDates.length === 0) || !isInputDataReady}
            >
              {/* 如果是學生，且學校規定要家長簽名，則出現「傳送給家長簽名」，否則出現「送出假單」 */}
              {((userInfo?.roleType === 'student') && (schoolOtherSettings?.need_parent_approval)) ? (i18n.language === "en" ? "Send to parent to sign" : "傳送給家長簽名") : (i18n.language === "en" ? "Send Leave Application" : "送出假單")}
            </Button>
          </div>
          <CardFooter className="!p-2" />
        </Card>
      </div>

      {/* 顯示請假規定 
      <Modal
        size="xl"
        closeOnOverlayClick={false}
        isOpen={isRuleOpen}
        onClose={onRuleClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader />
          <ModalCloseButton />

          <ModalBody className="!px-3">
            <object
              data="/assets/pdf/rule.pdf"
              type="application/pdf"
              title="請假規定"
              width="100%"
              className="min-h-[600px]"
            />
          
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal> /*}

      {/* 顯示家長簽名的視窗 */}
      <Modal
        closeOnOverlayClick={false}
        isOpen={isSignOpen}
        onClose={onSignClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className="!font-normal">
            {t("app.parent_sing_info")}
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            <div className="h-52 w-full border border-gray-200">
              <SignatureCanvas
                penColor="blue"
                ref={sigCanvas}
                canvasProps={{ className: "sigCanvas w-full h-52" }}
              />
            </div>
          </ModalBody>

          <ModalFooter className="gap-4">
            <Button
              colorScheme="twitter"
              variant="outline"
              className="mr-auto w-full"
              onClick={clear}
            >
              {t("app.clear")}
            </Button>
            <Button
              colorScheme="twitter"
              className="w-full"
              onClick={() => {
                save();
                onSignClose();
              }}
            >
              {t("app.confirm")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* 通用錯誤與提示視窗 */}
      <DialogBox
        isOpen={isAlertDialogOpen}
        title={t("app.error")}
        msg={alertMessage}
        closeButtonText="關閉"
        showCancelButton={false}
        okButtonText="確定"
        onOK={() => setIsAlertDialogOpen(false)}
      />
      {/* 提醒使用者學校資料尚未設定完全的視窗 */}
      <DialogBox
        isOpen={isDialogBoxOpened}
        title={t("app.error")}
        msg="當學期未完成請假設定，目前無法請假！請系統管理員檢查上課日、節次及請假類別設定。"
        closeButtonText="取消"
        showCancelButton={false}
        okButtonText="返回"
        onOK={() => navigate(-1)}
      />
      <DialogBox
        isOpen={isDepartedStudentDialogBoxOpened}
        title={t("app.error")}
        msg={t("app.only_current_students")}
        closeButtonText="取消"
        showCancelButton={false}
        okButtonText="返回"
        onOK={() => navigate(-1)}
      />
      <PdfZoomModal
        isModalOpen={isPdfModalOpen}
        onModalClose={() => setIsPdfModalOpen(false)}
        pdfUrl="../assets/pdf/rule.pdf"
        title="請假單"
      />
      {/* 顯示載入中的視窗 */}
      <LoadingDialog isOpen={showLoading} />
    </>
  );
};
